module.exports = __webpack_public_path__ + "img/nb_3.b0d7e6f3.png";